import { SystemDescriptions } from "src/common/descriptions";
import { ServiceDebitStatus } from "src/common/models/serviceContractDebit";
import { formatToCurrency } from "src/common/util";
import { SummaryType } from "src/components/SearchableTable/types";
import { searchableTableUtils } from "src/components/SearchableTable/utils";

const descriptions = SystemDescriptions.PAGES.SERVICE_CONTRACT.SERVICE_CONTRACT_DEBITS

export enum ColumnsKeys {
    NO = 'key',
    CONTRACT_ID = 'payableContractId',
    DESCRIPTION = 'description',
    AMOUNT = 'amount',
    AMOUNT_PAYED = 'amountPayed',
    OUTSTANDING = 'outstanding',
    STATUS = 'status',
    CREATED_AT = 'createdAt',
    CUSTOMER = 'customer',
    ELLAPSED = 'ellapsed',
    ACTIONS = 'ACTIONS',
}

export const TABLE_COLUMNS: any = [
    {
        title: descriptions.TABLE_COLUMNS.ID,
        dataIndex: ColumnsKeys.NO,
        key: ColumnsKeys.NO,
        align: searchableTableUtils.alignment.centerAlign,
    },
    {
        title: descriptions.TABLE_COLUMNS.DESCRIPTION,
        dataIndex: ColumnsKeys.DESCRIPTION,
        key: ColumnsKeys.DESCRIPTION,
        align: searchableTableUtils.alignment.centerAlign,
    },
    {
        title: descriptions.TABLE_COLUMNS.TOTAL,
        dataIndex: ColumnsKeys.AMOUNT,
        key: ColumnsKeys.AMOUNT,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => formatToCurrency(value),
    },
    {
        title: descriptions.TABLE_COLUMNS.OUTSTANDING,
        dataIndex: ColumnsKeys.OUTSTANDING,
        key: ColumnsKeys.OUTSTANDING,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => formatToCurrency(value),
    },
    {
        title: descriptions.TABLE_COLUMNS.STATUS,
        dataIndex: ColumnsKeys.STATUS,
        key: ColumnsKeys.STATUS,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => {
            const dictionaryOfStatuses = {
                [ServiceDebitStatus.ABOLISHED]: descriptions.DEBIT_STATUS.ABOLISHED,
                [ServiceDebitStatus.EXPIRED]: descriptions.DEBIT_STATUS.EXPIRED,
                [ServiceDebitStatus.PAYED]: descriptions.DEBIT_STATUS.PAYED,
                [ServiceDebitStatus.PENDING_PAYMENT]: descriptions.DEBIT_STATUS.PENDING_PAYMENT,
            }

            return dictionaryOfStatuses[value]
        },
    },
    {
        title: descriptions.TABLE_COLUMNS.ELLAPSED,
        dataIndex: ColumnsKeys.ELLAPSED,
        key: ColumnsKeys.ELLAPSED,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => `${value} ${descriptions.DAYS}`
    },
];

export const summaryColumns: Partial<Record<ColumnsKeys, SummaryType>> = {
    [ColumnsKeys.AMOUNT]: SummaryType.SUM,
    [ColumnsKeys.OUTSTANDING]: SummaryType.SUM,
    [ColumnsKeys.NO]: SummaryType.COUNT,
}